/**
 * The height to give a box that is sized to fill the space left on screen
 * (SearchPage's `autoFitHeight`, DetailPageLayout's column).
 *
 * Whole pixels, rounded down: a fit a fraction of a pixel too tall overflows
 * its scroller. Where a scrollbar takes up room (Safari with a mouse attached,
 * Windows) the bar then narrows the content, the box's ResizeObserver
 * re-measures, the new fit no longer overflows, the bar goes away — and the
 * page shakes back and forth several times a second (PRO-799).
 *
 * Changes of a pixel or less keep the current height, so a measurement that
 * depends on the scrollbar's own presence can't flip between two values.
 * @param available - The raw space measured for the box, in px
 * @param min - The smallest height to give it
 * @param current - The height it has now, if one has been fitted
 * @returns The height to give it, in px
 */
export const settleFitHeight = (
  available: number,
  min: number,
  current: number | null,
): number => {
  const next = Math.max(min, Math.floor(available));
  if (current !== null && Math.abs(next - current) <= 1) return current;
  return next;
};
